import type L from "leaflet";
import type { MapCoreEvents } from "../core/api";
import type { Emitter } from "../core/events";
import type { DrawMode, LatLngTuple, ResolvedOptions } from "../core/options";
import type { MapStore } from "../core/store";
import type { SnapCandidate } from "../geo/snap";
import type { Labels } from "../i18n/labels";
import type { Snapper } from "./Snapper";

export type DrawPhase = "drawing" | "editing";

export type DrawHost = {
  map: L.Map;
  root: HTMLElement;
  labels: Labels;
  touch: boolean;
  reducedMotion: boolean;
  options: ResolvedOptions["draw"];
  events: Emitter<MapCoreEvents>;
  store: MapStore;
  snapCandidates(): SnapCandidate[];
};

export type ToolHost = {
  host: DrawHost;
  pane: string;
  renderer: L.Renderer;
  snapper: Snapper;
  points(): LatLngTuple[];
  editable(): boolean;
  phase(): DrawPhase;
  setPhase(phase: DrawPhase): void;
  commit(points: LatLngTuple[]): void;
  preview(points: LatLngTuple[]): void;
  replaceWithoutHistory(points: LatLngTuple[]): void;
  finish(): void;
  cancel(): void;
  splitAt(segmentIndex: number, point: LatLngTuple): void;
  selectVertex(index: number | null): void;
  selectedVertex(): number | null;
  showSegment(latlng: LatLngTuple, meters: number): void;
  hideSegment(): void;
};

export type Tool = {
  readonly mode: DrawMode;
  render(points: LatLngTuple[], valid: boolean): void;
  onMapClick(point: LatLngTuple, originalEvent: MouseEvent | null): void;
  onMapMouseMove(latlng: LatLngTuple, originalEvent: MouseEvent | null): void;
  onDoubleClick(): void;
  removeLast(): void;
  deleteSelectedVertex(): void;
  finishGesture(): void;
  setEditable(on: boolean): void;
  dispose(): void;
};

export const drawColor = "#0E6B7A";

export const drawInvalidColor = "#dc2626";
